import { CustomerPartNumberCollectionModel } from "@auer-steel/Services/AuerSteelApiModels";
import {
    getCustomerPartNumbers,
    GetCustomerPartNumbersApiParameter,
} from "@auer-steel/Services/CustomerPartNumberService";
import { AuerActions } from "@auer-steel/Store/AuerState";
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { DispatchProp } from "react-redux";

type HandlerType = ApiHandler<
    GetCustomerPartNumbersApiParameter,
    CustomerPartNumberCollectionModel,
    DispatchProp<AuerActions>
>;

export const LoadCustomerPartNumbers: HandlerType = async props => {
    props.dispatch({
        type: "Data/CustomerPartNumbers/BeginLoad",
        parameter: props.parameter,
    });

    props.apiParameter = { ...props.parameter };

    props.apiResult = await getCustomerPartNumbers(props.apiParameter);

    props.dispatch({
        type: "Data/CustomerPartNumbers/CompleteLoad",
        collection: props.apiResult,
        parameter: props.parameter,
    });
};

export const chain = [LoadCustomerPartNumbers];

const loadCustomerPartNumbers = createHandlerChainRunner(chain, "LoadCustomerPartNumbers");
export default loadCustomerPartNumbers;
